import L from 'leaflet';

const stopIcon = new L.Icon({
    iconUrl: require('../leaflet/Images/bus_stop_icon.png'),
    iconAnchor: new L.Point(11, 23),
    iconSize: new L.Point(23, 25)
});

const stopIconSelected = new L.Icon({
    iconUrl: require('../leaflet/Images/selected_bus_stop_icon.png'),
    iconAnchor: new L.Point(11, 23),
    iconSize: new L.Point(23, 25)
});

export { stopIcon, stopIconSelected };



// WEBPACK FOOTER //
// ./src/components/leaflet/StopIcon.js